import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ApplicationService } from '@core/data/application.service';
import { map } from 'rxjs/operators';
import { AppConstants } from '@core/constants/app';
import { ApplicationConfigService } from '@core/data/application-config.service';
import { ApplicationProgressResponse } from '@core/interfaces/api-responses';


export function ApplicationStatusCompletedGuardFn(
  next: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  const applicationService: ApplicationService = inject(ApplicationService);
  const applicationConfigService: ApplicationConfigService = inject(ApplicationConfigService);
  const router: Router = inject(Router);

  const applicationId = next.params?.applicationId;

  if (!applicationId) {
    return false;
  }
  return applicationService.getProgress(applicationId).pipe(
    map((stepsProgress: ApplicationProgressResponse) => {
      if (stepsProgress.status !== AppConstants.APP_STATUS_SUBMITTED) {
        router.navigate([AppConstants.DASHBOARD_PAGE]);
        return false;
      }
      applicationConfigService.setConfig(stepsProgress.id, stepsProgress.requestedEffectiveDate);
      return true;
    }));
}

